/**
 * Opent een pop-up (`custom-popup-modal`-section) vanaf een knop elders op de
 * site, met een link-fallback wanneer de ingevulde Pop-up ID niet bij een
 * bestaande pop-up hoort (bv. een typfout, of de section is nog niet
 * toegevoegd). Liquid kan dat verschil niet zien op rendertijd — de knop en de
 * pop-up-section renderen onafhankelijk van elkaar — dus de knop rendert
 * altijd als gewone link (`custom-header-cta.liquid`, `custom-button.liquid`)
 * en deze listener onderschept de klik alleen wanneer de pop-up daadwerkelijk
 * in de DOM staat.
 */

/** Pop-up die Locksmith's "Log in om te bestellen" vervangt (ClickUp 86cbhbw26). */
const LOGIN_CHOICE_POPUP_ID = 'popup-inloggen';

/**
 * @param {string} id
 * @returns {(HTMLElement & { showDialog: () => void }) | null}
 */
function findPopup(id) {
  const popup = document.getElementById(id);
  if (!popup || typeof /** @type {any} */ (popup).showDialog !== 'function') return null;
  return /** @type {any} */ (popup);
}

/**
 * Staat de knop zelf in een andere pop-up (bv. "Dealer worden" in de
 * inlogkeuze), sluit die dan eerst, zodat de pop-ups niet op elkaar liggen.
 * Wachten op closeDialog: die animeert en zet de scroll-lock van de body terug;
 * direct de volgende openen kan de scrollpositie laten verspringen.
 * @param {Element} trigger
 */
async function closeParentPopup(trigger) {
  const parent = /** @type {any} */ (trigger.closest('[id^="popup-"]'));
  if (parent && typeof parent.closeDialog === 'function') await parent.closeDialog();
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  // Locksmith's "Log in om te bestellen": eerst de keuze inloggen of dealer
  // worden, want op het Shopify-inlogscherm kan een niet-dealer zich nergens
  // aanmelden. De Inloggen-knop in die pop-up krijgt de link van de aangeklikte
  // knop, met return_url, zodat je na het inloggen terugkomt op het product.
  const loginButton = event.target.closest('a.locksmith-login-button');
  if (loginButton instanceof HTMLAnchorElement) {
    const choicePopup = findPopup(LOGIN_CHOICE_POPUP_ID);
    if (!choicePopup) return;

    event.preventDefault();
    choicePopup.querySelectorAll('a[href*="customer_authentication/login"]').forEach((link) => {
      link.setAttribute('href', loginButton.getAttribute('href') || link.getAttribute('href') || '');
    });
    choicePopup.showDialog();
    return;
  }

  const trigger = event.target.closest('[data-popup-trigger]');
  if (!(trigger instanceof HTMLElement)) return;

  const dialog = findPopup(trigger.dataset.popupTrigger || '');
  if (!dialog) return;

  // Pop-up gevonden: dialoog openen i.p.v. de eventuele link te volgen.
  event.preventDefault();
  closeParentPopup(trigger).then(() => dialog.showDialog());
});
